import { render, staticRenderFns } from "./PeopleTrafficCompetitionCheckbox.vue?vue&type=template&id=567ed76c&"
import script from "./PeopleTrafficCompetitionCheckbox.vue?vue&type=script&lang=js&"
export * from "./PeopleTrafficCompetitionCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports